/* unplugin-vue-components disabled */import script from "./HomeRightMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeRightMenu.vue?vue&type=script&setup=true&lang=js"

import "./HomeRightMenu.vue?vue&type=style&index=0&id=f24517e0&lang=less"

const __exports__ = script;

export default __exports__